<div class="top-section">
  <div class="center-content">
    <div *ngIf="currentStage === 'Email'">
      <div class="verification-container">
        <div class="verification-box">
          <div class="logo-container">
            <img alt="Growth99 Logo" class="logo" [src]="g99ColoredLogo" />
          </div>
          <div class="image-container">
            <img alt="Verification Illustration" [src]="mfaThumbnail" />
          </div>
          <div class="content-container">
            <h2>Forgot Password</h2>

            <p>
              Enter your email address and click on send request to receive the
              verification code.
            </p>
            <div *ngIf="errorMessage" class="error-section mt-1">
              <lib-g99-message-box
                [message]="errorMessage"
                [messageColor]="'#d92d21'"
                [icon]="exclamationSvg"
                [iconColor]="'#d92d21'"
              />
            </div>

            <!-- ----------------------------------------------------------------------- -->
            <!--                          Forget Password FOrm                           -->
            <!-- ----------------------------------------------------------------------- -->

            <form [formGroup]="forgotPasswordForm">
              <!-- ---------------------- Email Field ---------------------- -->
              <div class="form-group">
                <lib-input
                  formControlName="email"
                  [label]="'Email'"
                  [isInvalid]="isInvalid('email')"
                  [placeholder]="'Enter email'"
                  [formControls]="f['email'] || null"
                  [errorMessage]="errorMessages.email"
                />
              </div>

              <!-- Submit Button For Rquest Confirmation COde -->
              <div class="form-group">
                <div class="button-flex">
                  <g99-button
                    width="100%"
                    variant="medium"
                    color="green"
                    [disabled]="!forgotPasswordForm.valid"
                    [loadingText]="'Sending request ...'"
                    [isLoading]="isLoading"
                    (buttonClick)="requestForConfirmationCode()"
                  >
                    Send Request
                  </g99-button>
                </div>
              </div>

              <!-- Additional Options -->
              <g99-auth-additional-option-footer />
            </form>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="currentStage === 'OTP'">
      <div class="verification-container">
        <div class="verification-box">
          <div class="image-container">
            <img alt="Verification Illustration" [src]="mfaThumbnail" />
          </div>
          <div class="content-container">
            <h2>Reset Password</h2>
            <p
              >For your security, please enter the confirmation code to reset
              your password and regain access to your account.</p
            >

            <div class="password-requirements">
              <p>Your password must meet the following criteria:</p>
              <ul>
                <li>At least 12 characters long</li>
                <li>Include at least one lowercase letter (e.g., a, b, c)</li>
                <li>Include at least one uppercase letter (e.g., A, B, C)</li>
                <li>Include at least one numeric digit (e.g., 0, 1, 2)</li>
                <li
                  >Include at least one special character (e.g., !, &#64; #,
                  $)</li
                >
              </ul>
            </div>

            <form [formGroup]="forgotPasswordForm">
              <div class="form-content">
                <div *ngIf="errorMessage" class="error-section mt-1">
                  <lib-g99-message-box
                    [message]="errorMessage"
                    [messageColor]="'#d92d21'"
                    [icon]="exclamationSvg"
                    [iconColor]="'#d92d21'"
                  />
                </div>

                <!-- ---------------------- Email Field ---------------------- -->
                <div class="form-group">
                  <lib-input
                    formControlName="email"
                    [label]="'Enter Email'"
                    [isInvalid]="isInvalid('email')"
                    [placeholder]="'Enter email'"
                    [formControls]="f['email'] || null"
                    [isReadonly]="true"
                    [errorMessage]="errorMessages.email"
                  />
                </div>

                <!-- New Password Field -->
                <div class="form-group">
                  <lib-input
                    formControlName="password"
                    [label]="'Enter New Password'"
                    [isInvalid]="isInvalid('password')"
                    [formControls]="f['password'] || null"
                    [inputType]="'password'"
                    [errorMessage]="errorMessages.password"
                  />
                </div>

                <!-- Confirm Password Field -->
                <div class="form-group">
                  <lib-input
                    formControlName="confirmPassword"
                    [label]="'Re-enter New Password'"
                    [isInvalid]="isInvalid('confirmPassword')"
                    [formControls]="f['confirmPassword'] || null"
                    [inputType]="'password'"
                    [errorMessage]="errorMessages.confirmPassword"
                  />
                </div>

                <!-- ----------------------------- Code field ------------------------------ -->
                <div class="form-group">
                  <label for="confirmationCode" class="code-label">
                    Enter Confirmation Code <span>*</span>
                    <span class="fw-normal">
                      (Please enter the confirmation code received on your email
                      from
                      <i>{{ emailText }}</i
                      >)
                    </span>
                  </label>

                  <lib-input
                    formControlName="confirmationCode"
                    [isInvalid]="isInvalid('confirmationCode')"
                    [formControls]="f['confirmationCode'] || null"
                    [errorMessage]="errorMessages.confirmationCode"
                  />
                </div>

                <!-- Submit Button For Submit Email To Recover Password -->
                <div class="form-group">
                  <div class="button-flex">
                    <g99-button
                      width="100%"
                      variant="medium"
                      color="green"
                      [disabled]="!forgotPasswordForm.valid"
                      [loadingText]="'verifying ...'"
                      [isLoading]="isLoading"
                      (buttonClick)="processPasswordReset()"
                    >
                      Verify
                    </g99-button>
                  </div>
                </div>

                <!-- Additional Options -->
                <g99-auth-additional-option-footer />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
